import { assign } from 'lodash'
import { warning } from '@/utils/alert'

export default {
  doSave () {
    const password = assign({}, this.password)
    if (password.password !== password.confirmed) {
      return warning('As senhas não conferem!')
    }

    this.$resource.update('', password)
      .then(({data}) => {
        this.password = {
          password: null,
          confirmed: null,
          current_password: null
        }
        this.show = true
      })
      .catch(({data, meta}) => {
        this.errors = data
        warning(meta.message)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/components/resources/methods.js